<template>
  <v-card class="mt-5">
    <v-toolbar class="white--text" color="indigo" dense flat>
      <v-toolbar-title>IMPOSTAZIONI</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Vai alla Dashboard</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text style="max-height: 70vh; overflow-y: scroll">
      <v-row justify="center" align="center" class="pa-4">
        <v-col cols="4">
          <div @click="showTurni" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-account-clock-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                ><span class="primary--text" style="font-size: 25px"
                  >Turni</span
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickRicercaMagazzino" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-store-search-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                ><span class="primary--text" style="font-size: 20px"
                  >Ricerca Magazzino</span
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickCausaliScarto" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-package-variant-remove
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Causali di Scarto
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickCausaliFermo" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-stop-circle-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                ><span class="primary--text" style="font-size: 20px"
                  >Causali di Fermo</span
                >
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickFaseStandard" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-vector-circle-variant
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Fasi Standard
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickCicloStandard" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-shape-circle-plus
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Ciclo Standard
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!--<v-col cols="4">
          <div @click="clickMacchinaProtocol" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-account-search-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Anagrafica QC Box
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>-->
        <v-col
          cols="4"
          v-if="
            cod_profilo === 'CNXBOX' ||
            cod_profilo === 'manager' ||
            cod_profilo === 'ADMIN' ||
            cod_profilo === 'Admin' ||
            cod_profilo === 'capobarca' ||
            cod_profilo === 'SVIL'
          "
        >
          <div @click="clickGestioneReparto" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-account-wrench-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Gestione Reparto
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickMovimenti" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary">
                  mdi-view-grid-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Categorie Movimenti
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickConfigurazioneReparto" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-store-cog </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Configurazione Reparto
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickConfigurazioneReparto2" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-store-cog </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Configurazione Reparto 2
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickCalendario" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-calendar </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Calendario
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickTipiSegnalazione" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-alert </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Tipi Segnalazione
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickReportCommessa" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-file-pdf-box </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Configurazione Report Commessa
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="4">
          <div @click="clickConfigurazioneMacchine" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-robot-industrial </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Configurazione Macchine
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
         <v-col cols="4">
          <div @click="clickCampiMacchine" class="consuntivi-card">
            <v-row>
              <v-col>
                <v-icon size="60" color="primary"> mdi-eye-off </v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text" style="font-size: 20px">
                  Campi macchine
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- <v-col class="" cols="12">
          <v-btn class="elevation-5" @click="showTurni" medium>
            <span class="primary--text" style="font-size: 35px">Turni</span>
          </v-btn>
        </v-col> -->
        <!-- <v-col class="" cols="12">
          <v-btn class="elevation-5" @click="clickCausaliScarto" medium>
            <span class="primary--text" style="font-size: 35px"
              >Causali di Scarto</span
            >
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="12" class="my-1">
          <v-btn class="elevation-5" @click="clickCausaliFermo" medium>
            <span class="primary--text" style="font-size: 35px"
              >Causali di Fermo</span
            >
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-btn class="elevation-5" @click="clickFaseStandard" medium>
            <span class="primary--text" style="font-size: 35px"
              >Fasi Standard</span
            >
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-btn class="elevation-5" @click="clickCicloStandard" medium>
            <span class="primary--text" style="font-size: 35px"
              >Ciclo Standard</span
            >
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-btn class="elevation-5" @click="clickRicercaMagazzino" medium>
            <span class="primary--text" style="font-size: 35px"
              >Ricerca Magazzino</span
            >
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="12">
          <v-btn class="elevation-5" @click="clickMacchinaProtocol" medium>
            <span class="primary--text" style="font-size: 35px"
              >Anagrafica QC Box</span
            >
          </v-btn>
        </v-col> -->

        <!-- <v-col cols="12">
          <v-btn
            class="elevation-5"
            @click="clickGestioneReparto"
            medium
            v-if="
              cod_profilo === 'CNXBOX' ||
              cod_profilo === 'MANAGER' ||
              cod_profilo === 'ADMIN' ||
              cod_profilo === 'Admin' ||
              cod_profilo === 'SVIL'
            "
          >
            <span class="primary--text" style="font-size: 35px">
              Gestione Reparto
            </span>
          </v-btn>
        </v-col> -->

        <!-- <v-col cols="12">
          <v-btn class="elevation-5" @click="clickMovimenti" medium>
            <span class="primary--text" style="font-size: 35px"
              >Categorie Movimenti</span
            >
          </v-btn>
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "Menu",
  components: {},
  data() {
    return {
      cod_profilo: null,
    };
  },
  computed: {},
  methods: {
    showTurni() {
      this.$emit("click_turni");
    },
    gotoDashboard() {
      this.$emit("go_to_dashboard");
    },

    clickCalendario() {
      this.$emit("click_calendario");
    },
    clickCausaliFermo() {
      this.$emit("click_causali_fermo");
    },
    clickCausaliScarto() {
      this.$emit("click_causali_scarto");
    },
    clickCicloStandard() {
      this.$emit("click_ciclo_standard");
    },
    clickFaseStandard() {
      this.$emit("click_fase_standard");
    },
    clickGestioneReparto() {
      this.$emit("click_gestione_reparto");
    },
    clickMacchinaProtocol() {
      this.$emit("click_macchina_protocol");
    },
    clickRicercaMagazzino() {
      this.$emit("click_ricerca_magazzino");
    },
    clickMovimenti() {
      this.$emit("click_movimenti");
    },

    clickConfigurazioneReparto() {
      this.$emit("click_config_reparto");
    },
    clickConfigurazioneReparto2() {
      this.$emit("click_config_reparto2");
    },
    clickReportCommessa() {
      this.$emit("click_report_commessa");
    },
    clickTipiSegnalazione() {
      this.$emit("click_tipi_segnalazione");
    },
    clickConfigurazioneMacchine(){
      this.$emit("click_configurazione_macchine");
    },
    clickCampiMacchine(){
      this.$emit("click_campi_macchine");
    },
  },
  mounted() {
    this.cod_profilo = localStorage.cod_profilo;
  },
};
</script>

<style scoped>
.consuntivi-card {
  margin: 2px;
  padding: 20px;
  height: 200px;
  background-color: rgba(248, 241, 241, 0.596);
  border-radius: 6px;
  -webkit-box-shadow: 0px 5px 14px -4px #8a8a8a;
  -moz-box-shadow: 0px 5px 14px -4px #8a8a8a;
  -o-box-shadow: 0px 5px 14px -4px #8a8a8a;
  box-shadow: 0px 5px 14px -4px #a4a4a4;
}

.consuntivi-card:hover {
  background-color: rgba(238, 228, 228, 0.596);
  -webkit-box-shadow: 0px 5px 14px -9px #8a8a8a;
  -moz-box-shadow: 0px 5px 14px -9px #8a8a8a;
  -o-box-shadow: 0px 5px 14px -9px #8a8a8a;
  box-shadow: 0px 5px 14px -9px #8a8a8a;
}
</style>
